import { Box, Typography } from '@material-ui/core';
import { SentimentDissatisfied } from '@material-ui/icons';
import React from 'react';

export function NotFoundFilterResponse(): JSX.Element {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
      <SentimentDissatisfied style={{ fontSize: '3rem', color: 'gray' }} />
      <Typography variant="h6" style={{ textAlign: 'center', color: 'gray', marginTop: '10px' }}>
        Nenhum conteúdo encontrado para os filtros selecionados.
      </Typography>
      <Typography variant="body2" style={{ textAlign: 'center', color: 'gray', marginTop: '5px' }}>
        Tente ajustar sua pesquisa ou explorar outras categorias.
      </Typography>
    </Box>
  );
}
